import { HStack, Link } from "@chakra-ui/react";
import Button from "../ui/Button";
import React from "react";
import { newUserDatabaseAuthenticationRegistrationPath, newUserSessionPath } from "../../../../../routes";

export const HeaderLoginActions = () => {
  return (
    <HStack h="full" gap={0}>
      <Button
        as={Link}
        textDecoration="none"
        href={newUserSessionPath()}
        variant="solid"
        color="white"
        fontSize="sm"
        h="full"
        borderRadius={0}
        px={4}
      >
        ログイン
      </Button>
      <Button
        as={Link}
        textDecoration="none"
        href={newUserDatabaseAuthenticationRegistrationPath()}
        h="full"
        borderRadius={0}
        fontSize="sm"
        px={4}
      >
        会員登録 (無料)
      </Button>
    </HStack>
  );
};
